(() => {
  if (customElements.get('accordion-group')) {
    return;
  }

  class AccordionGroup extends HTMLElement {
    constructor() {
      super();

      this.onOpenAccordion = this.onOpenAccordion.bind(this);
    }

    connectedCallback() {
      this.init();
      this.attachEvents();
    }

    disconnectedCallback() {
      this.detachEvents();
    }

    attachEvents() {
      this.accordions.forEach(accordion => {
        accordion.addEventListener('accordion:open', this.onOpenAccordion);
      });
    }

    detachEvents() {
      this.accordions.forEach(accordion => {
        accordion.removeEventListener('accordion:open', this.onOpenAccordion);
      });
    }

    init() {
      this.accordions = Array.from(this.querySelectorAll(':scope > accordion-element, :scope > footer-accordion'));
    }

    onOpenAccordion(event) {
      const target = event.target;

      if (target.closest('accordion-group') !== this) {
        return;
      };

      this.closeAllAccordions(target);
    }

    closeAllAccordions(currentAccordion) {
      this.accordions.forEach(accordion => accordion !== currentAccordion && accordion.close());
    }
  }

  customElements.define('accordion-group', AccordionGroup);
})();
